// табы

import GraphTabs from 'graph-tabs';
import {isDesktop, isMobile, isTablet} from "../../functions/check-viewport";
function TabsDefault() {
  const tabs = new GraphTabs('tab', {

  });



  const tabsContainer = document.getElementById('tabs');
  const tabsBtn = tabsContainer.querySelectorAll('ul li button');
  const tabsPanel = tabsContainer.querySelectorAll('.tabs__panel');

  setTimeout (() => {
    deleteButton(6)

  },1)
  function deleteButton(number) {
      tabsPanel.forEach((tabPanel) => {
        const tabItems = tabPanel.querySelectorAll('.blockTabs__card').length;
        const tabButton = tabPanel.querySelector('.blockTabs__button');

        if (isDesktop() || isTablet()) {
          if (tabItems <= 6) {
            tabButton.style.display = 'none';
          } else {
            return true;
          }
        }

        if (isMobile()) {
          if (tabItems <= 3) {
            tabButton.style.display = 'none';
          } else {
            return true;
          }
        }



      })

  }
  function ButtonTabs() {
    tabsBtn.forEach((tabBtn) => {
      tabBtn.addEventListener('click', function () {
        tabsBtn.forEach((tabBtn) => {
          tabBtn.classList.remove('true');
        })
        tabBtn.classList.add('true');
      })
    })
  }





  function ShowMore() {
    tabsPanel.forEach((tabPanel) => {
      const tabsBtnAlso = tabPanel.querySelector('.btn--also');
      const tabsCards = tabPanel.querySelectorAll('.blockTabs__card');
      tabsBtnAlso.addEventListener('click', function () {
        this.classList.toggle('true')
        tabsCards.forEach((tabsCard, index) => {
          tabsCard.classList.toggle('true');
          setTimeout(() => {
            tabsCard.classList.toggle('active');
          }, 100)


        })
      })
    })
  }

  (function init() {
    ButtonTabs()
    ShowMore()
  })();


}

export {
  TabsDefault
}
